import ThemeComposite from "./ThemeComposite";
import ThemeDevextreme from "./ThemeDevextreme";
import ThemeLocalStorage from "./ThemeLocalStorage";
import ThemeDocumentElement from "./ThemeDocumentElement";
import getTheme from "../../utils/getTheme";

function ThemeInit() {
  window.theme = {};

  window.theme.composite = new ThemeComposite();

  window.theme.composite.Register("localStorage", new ThemeLocalStorage());
  window.theme.composite.Register(
    "documentElement",
    new ThemeDocumentElement()
  );
  window.theme.composite.Register("devExtreme", new ThemeDevextreme());

  const theme = getTheme();

  window.theme.composite.SetTheme(theme);
}

function IsThemeInitialized() {
  return !!window.theme;
}

const ThemeConfig = { ThemeInit, IsThemeInitialized };

export default ThemeConfig;
